// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feature-label[data-v-550b377b]{color:#fff;border-radius:var(---border-radius)}.feature-label-title[data-v-550b377b]{font-weight:800;color:#fff}.feature-label-number[data-v-550b377b]{color:#fff;font-weight:700;line-height:120px}.feature-label-description[data-v-550b377b]{color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
